export function Tabs({
  activeTab,
  setActiveTab,
  isNewEmployee = false,
  isRejoinPrefill = false,
  isOnboardingMode = false,
  onboardingOrgSubmitted = false,
  onCloseForm,
  isEmployeeView = false,
  employee = {},
  availableTabs = null, // Progression lock: new-employee ESS onboarding only
  allowedByPermissionTabs = null,
}) {
  // ✅ Determine PF applicability safely from multiple sources
  const isPfApplicable =
    employee?.pfApplicable === true ||
    employee?.orgDetails?.pfApplicable === true ||
    employee?.statutoryApplicability?.pfApplicable === true;

  // ✅ Determine ESI applicability safely from multiple sources
  const isEsiApplicable =
    employee?.esiApplicable === true ||
    employee?.orgDetails?.esiApplicable === true ||
    employee?.statutoryApplicability?.esiApplicable === true;

  // ✅ Tabs list (Statutory Details included if PF or ESI is applicable)
  const tabs = [
    { id: "org", label: "Org Details" },
    { id: "personal", label: "Personal" },
    { id: "family", label: "Family" },
    { id: "bank", label: "Bank" },
    { id: "educational", label: "Education" },
    { id: "professional", label: "Profession" },
    ...(isPfApplicable || isEsiApplicable
      ? [{ id: "statutory", label: "Statutory Details" }]
      : []),
    { id: "documents", label: "Documents" },
  ];

  const hideTabsWithoutViewAccess =
    isEmployeeView && Array.isArray(allowedByPermissionTabs);

  const tabsToRender = hideTabsWithoutViewAccess
    ? tabs.filter((t) => allowedByPermissionTabs.includes(t.id))
    : tabs;

  return (
    <div className="relative z-10 flex h-12 border-b border-[hsl(var(--ds-border))] bg-white font-sans subpixel-antialiased dark:border-[hsl(var(--ds-border))] dark:bg-[hsl(var(--ds-surface))]">
      {tabsToRender.map((tab) => {
        const isOrgFirstLock =
          (isNewEmployee && !isRejoinPrefill && !isOnboardingMode && tab.id !== "org") ||
          (isOnboardingMode && !onboardingOrgSubmitted && tab.id !== "org");

        const isProgressionLocked =
          isEmployeeView &&
          isNewEmployee &&
          !isRejoinPrefill &&
          Array.isArray(availableTabs) &&
          !availableTabs.includes(tab.id);

        const isDisabled = isOrgFirstLock || isProgressionLocked;

        return (
          <button
            key={tab.id}
            type="button"
            className={`relative py-3 px-4 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ds-primary))]/40 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-[hsl(var(--ds-surface))] ${
              activeTab === tab.id
                ? "bg-white text-[hsl(var(--ds-fg))] dark:bg-[hsl(var(--ds-surface))] dark:text-[hsl(var(--ds-fg))]"
                : isDisabled
                ? "cursor-not-allowed bg-white text-[hsl(var(--ds-muted-fg))] dark:bg-[hsl(var(--ds-surface))]"
                : "bg-white text-[hsl(var(--ds-fg))]/80 hover:bg-gray-50 hover:text-[hsl(var(--ds-fg))] dark:bg-[hsl(var(--ds-surface))] dark:text-[hsl(var(--ds-fg))]/80 dark:hover:bg-[hsl(var(--ds-muted))] dark:hover:text-[hsl(var(--ds-fg))]"
            }`}
            onClick={() => !isDisabled && setActiveTab(tab.id)}
            disabled={isDisabled}
            title={
              isOrgFirstLock
                ? "Complete Organization Details first"
                : isProgressionLocked
                ? "Complete previous sections to unlock this tab"
                : ""
            }
          >
            {tab.label}
            {activeTab === tab.id && (
              <span className="absolute inset-x-2 bottom-0 h-0.5 rounded-full bg-[hsl(var(--ds-primary))]" />
            )}
          </button>
        );
      })}
    </div>
  );
}
